import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=27784ea4&scoped=true&"
import script from "./FilterItem.vue?vue&type=script&lang=js&"
export * from "./FilterItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterItem.vue?vue&type=style&index=0&id=27784ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27784ea4",
  null
  
)

export default component.exports